import { render, staticRenderFns } from "./ProjectResponses.vue?vue&type=template&id=020716a2"
import script from "./ProjectResponses.vue?vue&type=script&lang=js"
export * from "./ProjectResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports